import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import {
  makeStyles,
  Card,
  CardActions,
  CardContent,
  Button,
  Grid,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import Crossicon from "../../Assets/Images/Icon/cross.png";
import TickIcon from "../../Assets/Images/Icon/tick.png";
import SectionCard from "../../Components/Card/SectionCard";
import Layout from "../../Components/Layout/Layout";
import { getAllData } from "../../Redux/action/action";

const useStyles = makeStyles((theme) => ({
  topDiv: {
    fontSize: "2rem",
    "& .MuiGrid-container": {
      "&:nth-of-type(1)": {
        color: "#fff",
        // padding: '0.1rem 0rem',
        "& .MuiGrid-item": {
          "& h5": {
            borderBottom: "0.01rem solid #8C8C8C",
            "&:last-of-type": {
              borderBottom: "none",
            },
          },
          "&:last-of-type": {
            backgroundColor: "#094567",
          },
          "&:first-of-type": {
            backgroundColor: "#454545",
          },
        },
      },
    },
  },
  root: {
    minWidth: "100%",
    margin: "0.5rem 0rem",
    "&:.MuiCardContent-root": {
      padding: "0px",
      "&:last-child": {
        paddingBottom: "0px",
      },
    },
    "& .MuiGrid-container": {
      "&:nth-of-type(1)": {
        backgroundColor: "rgb(16, 16, 16,0.7)",
        color: "#fff",
        fontSize: "2rem",
        [theme.breakpoints.down("md")]: {
          fontSize: "1.5rem",
        },
        // padding: '0.1rem 0rem',
        "& .MuiGrid-item": {
          "&:first-of-type": {
            paddingBottom: "0.5rem",
          },
        },
      },
      "&:nth-of-type(2)": {
        backgroundColor: "rgb(190,190,190,0.7)",
        color: "#fff",
        fontSize: "1.5rem",
        padding: "0.1rem 0rem 0.3rem",
      },
      "&:nth-of-type(3)": {
        backgroundColor: "rgb(16, 16, 16,0.7)",
        color: "#fff",
        fontSize: "1.5rem",
        // padding: '0.1rem 0rem 0.3rem',
        "& .MuiGrid-item": {
          padding: "0.1rem 0rem 0.3rem",
          "&:nth-of-type(1),&:nth-of-type(2),&:nth-of-type(3)": {
            borderRight: "0.1rem solid #fff",
            borderBottom: "0.1rem solid #fff",
          },
          "&:nth-of-type(4)": {
            // borderRight: '0.1rem solid #fff',
            borderBottom: "0.1rem solid #fff",
          },
          "&:first-of-type": {
            // borderRight: '0.1rem solid #fff',
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        },
      },
      "&:nth-of-type(4)": {
        backgroundColor: "rgb(16, 16, 16,0.7)",
        color: "#fff",
        fontSize: "1.5rem",
        // padding: '0.1rem 0rem 0.3rem',
        "& .MuiGrid-item": {
          padding: "0.1rem 0rem 0.3rem",
          "&:nth-of-type(1),&:nth-of-type(2),&:nth-of-type(3)": {
            borderRight: "0.1rem solid #fff",
            borderBottom: "0.1rem solid #fff",
          },
          "&:nth-of-type(4)": {
            // borderRight: '0.1rem solid #fff',
            borderBottom: "0.1rem solid #fff",
          },
          "&:first-of-type": {
            // borderRight: '0.1rem solid #fff',
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        },
      },
      "&:nth-of-type(5)": {
        backgroundColor: "rgb(16, 16, 16,0.7)",
        color: "#fff",
        fontSize: "1.5rem",
        "& .MuiGrid-item": {
          padding: "0.1rem 0rem 0.3rem",
          "&:nth-of-type(1),&:nth-of-type(2),&:nth-of-type(3)": {
            borderRight: "0.1rem solid #fff",
            borderBottom: "0.1rem solid #fff",
          },
          "&:nth-of-type(4)": {
            borderBottom: "0.1rem solid #fff",
          },
          "&:first-of-type": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        },
      },
      "&:nth-of-type(6)": {
        backgroundColor: "rgb(16, 16, 16,0.7)",
        color: "#fff",
        fontSize: "1.5rem",
        "& .MuiGrid-item": {
          padding: "0.1rem 0rem 0.3rem",
          "&:nth-of-type(1),&:nth-of-type(2),&:nth-of-type(3)": {
            borderRight: "0.1rem solid #fff",
            borderBottom: "0.1rem solid #fff",
          },
          "&:nth-of-type(4)": {
            borderBottom: "0.1rem solid #fff",
          },
          "&:first-of-type": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        },
      },
      "&:nth-of-type(7)": {
        backgroundColor: "rgb(16, 16, 16,0.7)",
        color: "#fff",
        fontSize: "1.5rem",
        "& .MuiGrid-item": {
          padding: "0.1rem 0rem 0.3rem",
          "&:nth-of-type(1),&:nth-of-type(2),&:nth-of-type(3)": {
            borderRight: "0.1rem solid #fff",
            borderBottom: "0.1rem solid #fff",
          },
          "&:nth-of-type(4)": {
            borderBottom: "0.1rem solid #fff",
          },
          "&:first-of-type": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        },
      },
    },
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  imgSize: {
    width: "25px",
    height: "25px",
  },
}));
const Report = () => {
  const dispatch = useDispatch();
  const { test } = useParams();
  const classes = useStyles();
  let totalMarksResult;
  let totalMarks;
  let reportData = [];
  let examResult = [];
  const if_inglish = useSelector((state) => state.english);
  const allExams = useSelector((state) => state.allExams);
  const { success, exam, error } = allExams;
  examResult = exam && exam.slice(-1)[0];
  const { testName, testDate, answerGiven, questionAsked } =
    examResult != undefined && examResult.exam;
  reportData = test && exam && exam[test - 1];

  const {
    testName: resultName,
    testDate: resultTime,
    answerGiven: resultAnswerGiven,
    questionAsked: resultQuestionAsked,
  } = reportData != undefined && reportData.exam;
  if (examResult != undefined) {
    totalMarks = answerGiven
      .map((item, index) => {
        if (
          item.zameerWahidJama == questionAsked[index].zameerWahidJama &&
          item.zameerJins == questionAsked[index].zameerJins &&
          item.name == questionAsked[index].name
        ) {
          return 1;
        } else {
          return 0;
        }
      })
      .reduce((a, b) => a + b, 0);
  }

  if (reportData != undefined) {
    if (test && resultName.includes("Translation")) {
      totalMarksResult = resultAnswerGiven
        .map((item, index) => {
          if (item.translation == resultQuestionAsked[index].translation) {
            return 1;
          } else {
            return 0;
          }
        })
        .reduce((a, b) => a + b, 0);
    } else if (test && resultName.includes("ثلاثی مزید فیہ")) {
      totalMarksResult = resultAnswerGiven
        .map((item, index) => {
          if (
            (item.zameerWahidJama ==
              resultQuestionAsked[index].zameerWahidJama &&
              item.zameerJins == resultQuestionAsked[index].zameerJins &&
              item.name == resultQuestionAsked[index].name,
            item.baabName == resultQuestionAsked[index].baabName,
            item.baab == resultQuestionAsked[index].baab)
          ) {
            return 1;
          } else {
            return 0;
          }
        })
        .reduce((a, b) => a + b, 0);
    } else if (testName && testName.includes("Translation")) {
      totalMarksResult = answerGiven
        .map((item, index) => {
          if (item.translation == questionAsked[index].translation) {
            return 1;
          } else {
            return 0;
          }
        })
        .reduce((a, b) => a + b, 0);
    } else if (test) {
      totalMarksResult = resultAnswerGiven
        .map((item, index) => {
          if (
            item.zameerWahidJama ==
              resultQuestionAsked[index].zameerWahidJama &&
            item.zameerJins == resultQuestionAsked[index].zameerJins &&
            item.name == resultQuestionAsked[index].name
          ) {
            return 1;
          } else {
            return 0;
          }
        })
        .reduce((a, b) => a + b, 0);
    }
  }

  useEffect(() => {
    dispatch(getAllData());
  }, [dispatch]);

  return (
    <div>
      <Navbar />
      {!success ? (
        <div>
          <div
            style={{
              display: "flex",
              height: "100vh",
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
            className="questionCardHeadings result-page result-page-content"
          >
            <Typography style={{ color: "black" }} variant="h3">
              <CircularProgress />
            </Typography>
          </div>
        </div>
      ) : (
        <Layout mainClassName="" title="التصریف">
          {test && resultName.includes("ثلاثی مزید فیہ") ? (
            <>
              <SectionCard>
                <div className={classes.topDiv}>
                  <Grid container justify="space-between" alignItems="center">
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      {if_inglish ? (
                        <>
                          <h5>Name</h5>
                          <h5>Time</h5>
                          <h5>Marks</h5>
                        </>
                      ) : (
                        <>
                          <h5>نام</h5>
                          <h5>تاریخ</h5>
                          <h5>مارک</h5>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <h5>{resultName}</h5>
                      <h5>{resultTime}</h5>
                      <h5>{totalMarks}</h5>
                    </Grid>
                  </Grid>
                </div>
              </SectionCard>
              <SectionCard>
                {resultAnswerGiven.map((item, index) => (
                  <Card className={classes.root}>
                    <Grid container justify="space-between" alignItems="center">
                      {item.zameerWahidJama ==
                        resultQuestionAsked[index].zameerWahidJama &&
                      item.zameerJins ==
                        resultQuestionAsked[index].zameerJins &&
                      item.name == resultQuestionAsked[index].name &&
                      item.baabName == resultQuestionAsked[index].baabName &&
                      item.baab == resultQuestionAsked[index].baab ? (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "green" }}
                        >
                          {if_inglish ? <h3>Right</h3> : <h3>صحیع </h3>} صحیع
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "red" }}
                        >
                          {if_inglish ? <h3>Wrong</h3> : <h3>غلط </h3>}
                        </Grid>
                      )}

                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {index + 1}: {item.text}
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Result</h3> : <h3> نتیجا </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Answer</h3> : <h3> جواب </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Selected</h3> : <h3>سلیکٹڈ </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Section</h3> : <h3>سلیکشن </h3>}
                      </Grid>
                    </Grid>{" "}
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerWahidJama ==
                        resultQuestionAsked[index].zameerWahidJama ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {resultQuestionAsked[index].zameerWahidJama}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerWahidJama}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Adud
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerJins ==
                        resultQuestionAsked[index].zameerJins ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {resultQuestionAsked[index].zameerJins}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerJins}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Jins
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.name == resultQuestionAsked[index].name ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {resultQuestionAsked[index].name}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.name}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Segha
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.baabName ==
                        resultQuestionAsked[index].baabName ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {resultQuestionAsked[index].baabName}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.baabName}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Baab
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.baab == resultQuestionAsked[index].baab ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {resultQuestionAsked[index].baab}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.baab}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Noa-Baab
                      </Grid>
                    </Grid>
                  </Card>
                ))}
              </SectionCard>
            </>
          ) : test && resultName.includes("Translation") ? (
            <>
              <SectionCard>
                <div className={classes.topDiv}>
                  <Grid container justify="space-between" alignItems="center">
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      {if_inglish ? (
                        <>
                          <h5>Name</h5>
                          <h5>Time</h5>
                          <h5>Marks</h5>
                        </>
                      ) : (
                        <>
                          <h5>نام</h5>
                          <h5>تاریخ</h5>
                          <h5>مارک</h5>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <h5>{testName}</h5>
                      <h5>{testDate}</h5>
                      <h5>{totalMarksResult}</h5>
                    </Grid>
                  </Grid>
                </div>
              </SectionCard>
              <SectionCard>
                {resultAnswerGiven.map((item, index) => (
                  <Card className={classes.root}>
                    <Grid container justify="space-between" alignItems="center">
                      {item.translation ==
                      resultQuestionAsked[index].translation ? (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "green" }}
                        >
                          {if_inglish ? <h3>Right</h3> : <h3>صحیع </h3>}
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "red" }}
                        >
                          {if_inglish ? <h3>Wrong</h3> : <h3>غلط </h3>}
                        </Grid>
                      )}

                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {index + 1}: {item.text}
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Result</h3> : <h3> نتیجا </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Answer</h3> : <h3> جواب </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Selected</h3> : <h3>سلیکٹڈ </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Section</h3> : <h3>سلیکشن </h3>}
                      </Grid>
                    </Grid>{" "}
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.translation ==
                        resultQuestionAsked[index].translation ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {resultQuestionAsked[index].translation}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.translation}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Turjuma
                      </Grid>
                    </Grid>
                  </Card>
                ))}
              </SectionCard>
            </>
          ) : test ? (
            <>
              <SectionCard>
                <div className={classes.topDiv}>
                  <Grid container justify="space-between" alignItems="center">
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      {if_inglish ? (
                        <>
                          <h5>Name</h5>
                          <h5>Time</h5>
                          <h5>Marks</h5>
                        </>
                      ) : (
                        <>
                          <h5>نام</h5>
                          <h5>تاریخ</h5>
                          <h5>مارک</h5>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <h5>{resultName}</h5>
                      <h5>{resultTime}</h5>
                      <h5>{totalMarksResult}</h5>
                    </Grid>
                  </Grid>
                </div>
              </SectionCard>
              <SectionCard>
                {resultAnswerGiven.map((item, index) => (
                  <Card className={classes.root}>
                    <Grid container justify="space-between" alignItems="center">
                      {item.zameerWahidJama ==
                        resultQuestionAsked[index].zameerWahidJama &&
                      item.zameerJins ==
                        resultQuestionAsked[index].zameerJins &&
                      item.name == resultQuestionAsked[index].name ? (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "green" }}
                        >
                          {if_inglish ? <h3>Right</h3> : <h3>صحیع </h3>}
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "red" }}
                        >
                          {if_inglish ? <h3>Wrong</h3> : <h3>غلط </h3>}
                        </Grid>
                      )}

                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {index + 1}: {item.text}
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Result</h3> : <h3> نتیجا </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Answer</h3> : <h3> جواب </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Selected</h3> : <h3>سلیکٹڈ </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Section</h3> : <h3>سلیکشن </h3>}
                      </Grid>
                    </Grid>{" "}
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerWahidJama ==
                        resultQuestionAsked[index].zameerWahidJama ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {resultQuestionAsked[index].zameerWahidJama}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerWahidJama}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Adud
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerJins ==
                        resultQuestionAsked[index].zameerJins ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {resultQuestionAsked[index].zameerJins}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerJins}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Jins
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.name == resultQuestionAsked[index].name ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {resultQuestionAsked[index].name}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.name}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Segha
                      </Grid>
                    </Grid>
                  </Card>
                ))}
              </SectionCard>
            </>
          ) : testName && testName.includes("ثلاثی مزید فیہ") ? (
            <>
              <SectionCard>
                <div className={classes.topDiv}>
                  <Grid container justify="space-between" alignItems="center">
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      {if_inglish ? (
                        <>
                          <h5>Name</h5>
                          <h5>Time</h5>
                          <h5>Marks</h5>
                        </>
                      ) : (
                        <>
                          <h5>نام</h5>
                          <h5>تاریخ</h5>
                          <h5>مارک</h5>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <h5>{testName}</h5>
                      <h5>{testDate}</h5>
                      <h5>{totalMarks}</h5>
                    </Grid>
                  </Grid>
                </div>
              </SectionCard>
              <SectionCard>
                {answerGiven.map((item, index) => (
                  <Card className={classes.root}>
                    <Grid container justify="space-between" alignItems="center">
                      {item.zameerWahidJama ==
                        questionAsked[index].zameerWahidJama &&
                      item.zameerJins == questionAsked[index].zameerJins &&
                      item.name == questionAsked[index].name &&
                      item.baabName == questionAsked[index].baabName &&
                      item.baab == questionAsked[index].baab ? (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "green" }}
                        >
                          {if_inglish ? <h3>Right</h3> : <h3>صحیع </h3>}
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "red" }}
                        >
                          {if_inglish ? <h3>Wrong</h3> : <h3>غلط </h3>}
                        </Grid>
                      )}

                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {index + 1}: {item.text}
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Result</h3> : <h3> نتیجا </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Answer</h3> : <h3> جواب </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Selected</h3> : <h3>سلیکٹڈ </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Section</h3> : <h3>سلیکشن </h3>}
                      </Grid>
                    </Grid>{" "}
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerWahidJama ==
                        questionAsked[index].zameerWahidJama ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {questionAsked[index].zameerWahidJama}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerWahidJama}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Adud
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerJins == questionAsked[index].zameerJins ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {questionAsked[index].zameerJins}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerJins}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Jins
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.name == questionAsked[index].name ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {questionAsked[index].name}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.name}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Segha
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.baabName == questionAsked[index].baabName ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {questionAsked[index].baabName}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.baabName}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Baab
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.baab == questionAsked[index].baab ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {questionAsked[index].baab}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.baab}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Noa-Baab
                      </Grid>
                    </Grid>
                  </Card>
                ))}
              </SectionCard>
            </>
          ) : testName && testName.includes("Translation") ? (
            <>
              <SectionCard>
                <div className={classes.topDiv}>
                  <Grid container justify="space-between" alignItems="center">
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      {if_inglish ? (
                        <>
                          <h5>Name</h5>
                          <h5>Time</h5>
                          <h5>Marks</h5>
                        </>
                      ) : (
                        <>
                          <h5>نام</h5>
                          <h5>تاریخ</h5>
                          <h5>مارک</h5>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <h5>{testName}</h5>
                      <h5>{testDate}</h5>
                      <h5>{totalMarksResult}</h5>
                    </Grid>
                  </Grid>
                </div>
              </SectionCard>
              <SectionCard>
                {answerGiven.map((item, index) => (
                  <Card className={classes.root}>
                    <Grid container justify="space-between" alignItems="center">
                      {item.translation == questionAsked[index].translation ? (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "green" }}
                        >
                          {if_inglish ? <h3>Right</h3> : <h3>صحیع </h3>}
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "red" }}
                        >
                          {if_inglish ? <h3>Wrong</h3> : <h3>غلط </h3>}
                        </Grid>
                      )}

                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {index + 1}: {item.text}
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Result</h3> : <h3> نتیجا </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Answer</h3> : <h3> جواب </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Selected</h3> : <h3>سلیکٹڈ </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Section</h3> : <h3>سلیکشن </h3>}
                      </Grid>
                    </Grid>{" "}
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.translation ==
                        questionAsked[index].translation ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {questionAsked[index].translation}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.translation}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Turjuma
                      </Grid>
                    </Grid>
                  </Card>
                ))}
              </SectionCard>
            </>
          ) : (
            <>
              <SectionCard>
                <div className={classes.topDiv}>
                  <Grid container justify="space-between" alignItems="center">
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      {if_inglish ? (
                        <>
                          <h5>Name</h5>
                          <h5>Time</h5>
                          <h5>Marks</h5>
                        </>
                      ) : (
                        <>
                          <h5>نام</h5>
                          <h5>تاریخ</h5>
                          <h5>مارک</h5>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <h5>{testName}</h5>
                      <h5>{testDate}</h5>
                      <h5>{totalMarks}</h5>
                    </Grid>
                  </Grid>
                </div>
              </SectionCard>
              <SectionCard>
                {answerGiven.map((item, index) => (
                  <Card className={classes.root}>
                    <Grid container justify="space-between" alignItems="center">
                      {item.zameerWahidJama ==
                        questionAsked[index].zameerWahidJama &&
                      item.zameerJins == questionAsked[index].zameerJins &&
                      item.name == questionAsked[index].name ? (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "green" }}
                        >
                          {if_inglish ? <h3>Right</h3> : <h3>صحیع </h3>}
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ backgroundColor: "red" }}
                        >
                          {if_inglish ? <h3>Wrong</h3> : <h3>غلط </h3>}
                        </Grid>
                      )}

                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {index + 1}: {item.text}
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Result</h3> : <h3> نتیجا </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Answer</h3> : <h3> جواب </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Selected</h3> : <h3>سلیکٹڈ </h3>}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {if_inglish ? <h3>Section</h3> : <h3>سلیکشن </h3>}
                      </Grid>
                    </Grid>{" "}
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerWahidJama ==
                        questionAsked[index].zameerWahidJama ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {questionAsked[index].zameerWahidJama}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerWahidJama}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Adud
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerJins == questionAsked[index].zameerJins ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {questionAsked[index].zameerJins}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.zameerJins}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Jins
                      </Grid>
                    </Grid>
                    <Grid container>
                      {" "}
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.name == questionAsked[index].name ? (
                          <img className={classes.imgSize} src={TickIcon} />
                        ) : (
                          <img className={classes.imgSize} src={Crossicon} />
                        )}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {questionAsked[index].name}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        {item.name}
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        Segha
                      </Grid>
                    </Grid>
                  </Card>
                ))}
              </SectionCard>
            </>
          )}
        </Layout>
      )}
    </div>
  );
};

export default Report;
